import Lottie from 'react-lottie';
import animationData from 'assets/lottie/general/anim_11.json';

const Hero = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData
  };

  return (
    <div className="relative hero min-h-screen bg-gradient-to-r from-indigo-500 to-purple-600 text-white">
        <div className="hero-content flex flex-col lg:flex-row items-center text-center lg:text-left px-4 lg:px-20">
            {/* Lottie Animation for Large Screens */}
            <div className="hidden lg:block w-1/2 max-w-sm lg:mr-8">
            <Lottie options={defaultOptions} isClickToPauseDisabled={true} style={{cursor:"default"}}/>
            </div>

            {/* Text Content */}
            <div className="max-w-md">
            <h1 className="text-2xl font-body font-semibold uppercase tracking-wide">
                Welcome to
            </h1>
            <h1 className="text-6xl font-title font-extrabold leading-tight mt-2">
                <span
                style={{ fontFamily: 'Barriecito, sans-serif' }}
                className="text-yellow-400"
                >
                BitBit
                </span>{' '}
                Studio
            </h1>

            {/* Lottie Animation for Mobile */}
            <div className="block lg:hidden w-[70%] my-6 max-w-sm mx-auto">
                <Lottie options={defaultOptions} isClickToPauseDisabled={true} />
            </div>

            <p className="text-lg font-body leading-relaxed">
                We craft fresh, contemporary animations with a personal touch. Let's bring your vision to life, one frame at a time.
            </p>
            </div>
        </div>
        {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
            className="absolute bottom-0 w-full"
            preserveAspectRatio="none"
        >
            <path
                fill="#1D232A"
                d="M0,288L48,272C96,256,192,224,288,208C384,192,480,192,576,213.3C672,235,768,277,864,288C960,299,1056,277,1152,256C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            />
        </svg> */}
    </div>
  );
};

export default Hero;
